import React from "react"
// gotoPage,
// previousPage,
// canPreviousPage,
// nextPage,
// canNextPage,
// pageIndex,
// pageOptions,
// page,
// pageSize,
// totalEntries
const Pagi2 = ({
  gotoPage,
  previousPage,
  canPreviousPage,
  nextPage,
  canNextPage,
  pageIndex,
  pageOptions,
  pageSize,
}) => {
  let limitedPageOptions = pageOptions

  // If there are more than 30 pages, limit the displayed pages to 5
  if (pageOptions.length > 6) {
    const startIndex = Math.max(0, pageIndex - 2)
    const endIndex = Math.min(startIndex + 5, pageOptions.length)
    limitedPageOptions = pageOptions.slice(startIndex, endIndex)
  }

  const startEntry = pageIndex * pageSize + 1
  // const endEntry = Math.min(startEntry + pageSize - 1, totalEntries)

  // Total number of pages
  const totalPages = pageOptions.length

  return (
    <>
      <div className="d-flex justify-content-between align-items-center flex-wrap py-3 py-md-0">
        <p className="">
          Showing {pageIndex * 10 + 1} to{" "}
          {Math.min((pageIndex + 1) * 10, pageOptions.length * 10)} of{" "}
          {pageOptions.length * 10} entries
        </p>

        <nav aria-label="...">
          <ul className="pagination">
            <li
              className={`page-item ${canPreviousPage ? "" : "disabled"} `}
              onClick={previousPage}
            >
              <a className="page-link">Previous</a>
            </li>

            {limitedPageOptions.map(page => (
              <li
                key={page}
                onClick={() => gotoPage(page)}
                className={`page-item`}
              >
                <a
                  className={`page-link ${
                    page === pageIndex ? "bg-purple" : ""
                  } `}
                >
                  {page + 1}
                </a>
              </li>
            ))}

            <li
              className={`page-item ${canNextPage ? "" : "disabled"} `}
              onClick={nextPage}
            >
              <a className="page-link">Next</a>
            </li>
          </ul>
        </nav>
      </div>
    </>
  )
}

export default Pagi2
